// Demo URL for SportProject - set REACT_APP_SPORT_PROJECT_URL in .env for production
export const SPORT_PROJECT_DEMO_URL =
  process.env.REACT_APP_SPORT_PROJECT_URL || 'http://localhost:5174';

// Preview image for the featured project (screenshot or placeholder)
export const SPORT_PROJECT_IMAGE = '/SystemScreenShot.png';
